<template>
	<sf-data-table
		ref="comCdTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="comCdList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/ComCdPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('MWCC000150'),
					prop: 'commCd',
					minWidth: '20px',
					sortable: false
				},
				{
					label: this.getMessage_('MWCC000151'),
					prop: 'commCdName',
					minWidth: '60px',
					clickEvent: this.cpnyNmClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000988'),
					prop: 'refCd1',
					minWidth: '20px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000989'),
					prop: 'refCd2',
					minWidth: '20px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000990'),
					prop: 'refCd3',
					minWidth: '20px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000991'),
					prop: 'refCd4',
					minWidth: '20px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000992'),
					prop: 'refCd5',
					minWidth: '20px',
					sortable: false,
					highlight: true
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		cpnyNmClick(row) {
			this.$emit('SendData', row);
		}
	}
};
</script>

<style></style>
